var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"previous-step__container"},[(!_vm.tchekImages.completed)?_c('a',{staticClass:"previous-step__link",on:{"click":function($event){$event.preventDefault();return _vm.previousStep(_vm.step)}}},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }